import * as actionTypes from './actionTypes';
import { createActionObject } from '../../helpers/common';
import * as api from '../api';
import JSZip from 'jszip';

export const setSelectedStationName = stationName => dispatch => dispatch(
    createActionObject(
      actionTypes.SET_SELECTED_STATION_NAMES,
      { stationName }
    )
);

export const setCurrentDownloadConfigStation = stationName => dispatch => dispatch(
  createActionObject(
    actionTypes.CURRENT_DOWNLOAD_CONFIG_STATION,
    { stationName }
  )
);

export const callListDownloaConfigObjectApi = (payload) => dispatch => {
    api.listDownloadConfigObject(payload)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(
            createActionObject(
              actionTypes.LIST_DOWNLOAD_CONFIG_OBJECT,
              { data: data }
            )
          )
          // console.log("Data from API:", data);
        } else if (status === 500) {
          dispatch(
            createActionObject(
              actionTypes.LIST_DOWNLOAD_CONFIG_OBJECT,
              { data: null }
            )
          )
        }
      });
};

export const callGenerateDownloadConfigLinkApi = (payload) => dispatch => {
    api.generateDownloadConfigLink(payload)
      .then(({ data, status }) => {
        // Log the received data
        console.log("Received data:", data);
        
        if (status === 200) {
          dispatch(
            createActionObject(
              actionTypes.GENERATE_DOWNLOAD_CONFIG_LINK,
              { data: data }
            )
          );
  
          // Extract StationName from the file path
          const stationName = payload.fileList[0].split("/")[0]; // Assuming fileList is not empty
  
          // Create a new zip archive
          const zip = new JSZip();
          // Use Promise.all to wait for all fetch calls to complete
          Promise.all(
            data.downloadDataLinks.map(fileObject => {
                // Log the entire fileObject for debugging
                // console.log("File Object:", fileObject);
        
                // Ensure that downloadDataLinks is correctly accessed
                const downloadUrl = fileObject.downloadConfigLink;
        
                // Log the presigned URL
                // console.log("Presigned URL:", downloadUrl);
        
                // Fetch the file and continue processing
                return fetch(downloadUrl)
                    .then(response => response.blob())
                    .then(blob => zip.file(fileObject.fileName, blob));
            })
        )
          .then(() => {
            // Generate the zip file and trigger the download
            zip.generateAsync({ type: "blob" })
              .then(content => {
                // Combine StationName, CurrentDate, and "Download_Config" to form the zip file name
                const zipFileName = `SERIS_Download_Configuration_${stationName}.zip`;
  
                const zipFile = new File([content], zipFileName, { type: "application/zip" });
  
                // Trigger the download
                const url = window.URL.createObjectURL(zipFile);
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = zipFileName;
                a.click();
                window.URL.revokeObjectURL(url);
              })
              .catch(error => {
                console.error("Error generating zip file:", error);
              });
          })
          .catch(error => {
            console.error("Error fetching file data:", error);
          });
        } else if (status === 500) {
          dispatch(
            createActionObject(
              actionTypes.GENERATE_DOWNLOAD_CONFIG_LINK,
              { data: null }
            )
          );
        }
      })
      .catch(error => {
        console.error("Error downloading data:", error);
      });
  };    

export const clearSelectedFiles = () => dispatch => dispatch(
    createActionObject(
      actionTypes.CLEAR_SELECTED_FILES
    )
);